import React, { useState, useEffect } from "react";
import { FaPhone, FaWhatsapp, FaEnvelope, FaQrcode, FaCommentDots } from "react-icons/fa";
import { database } from "../firebaseConfig";
import { ref, get } from "firebase/database";
import ContactForm from "./ContactForm"; // Import ContactForm
import "./FloatingContactIcons.css";

const FloatingContactIcons = () => {
    const [config, setConfig] = useState(null);
    const [qrModalVisible, setQrModalVisible] = useState(false);
    const [inquireModalVisible, setInquireModalVisible] = useState(false);
    const [inquireResult, setInquireResult] = useState("");

    // Fetch configuration from Firebase on mount
    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const snapshot = await get(ref(database, "floatingIconsConfig"));
                if (snapshot.exists()) {
                    setConfig(snapshot.val());
                } else {
                    setConfig(null);
                }
            } catch (error) {
                console.error("Error fetching floating icons config:", error);
            }
        };
        fetchConfig();
    }, []);

    if (!config) return null;

    // Handle form submission for inquiry
    const onSubmitInquiry = async (formData, event) => {
        event.preventDefault();
        setInquireResult("Sending....");

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                body: formData,
            });
            const data = await response.json();

            if (data.success) {
                setInquireResult("Form Submitted Successfully. Our representative will reach out.");
                event.target.reset();
            } else {
                console.error("Error", data);
                setInquireResult(data.message);
            }
        } catch (error) {
            console.error("Submission error:", error);
            setInquireResult("We could not submit your form, please contact us via phone call or WhatsApp.");
        }
    };

    return (
        <>
            <div className="floating-contact-icons">
                {config.phone?.visible && (
                    <a href={`tel:${config.phone.number}`} className="contact-icon phone">
                        <FaPhone size={30} style={{ transform: 'scaleX(-1)' }} />
                    </a>
                )}

                {config.whatsapp?.visible && (
                    <a
                        href={`https://wa.me/${config.whatsapp.number}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-icon whatsapp"
                    >
                        <FaWhatsapp size={30} />
                    </a>
                )}
                {config.email?.visible && (
                    <a href={`mailto:${config.email.address}`} className="contact-icon email">
                        <FaEnvelope size={30} />
                    </a>
                )}
                {config.scan?.visible && (
                    <div className="contact-icon scan" onClick={() => setQrModalVisible(true)}>
                        {config.scan.qrImageUrl ? (
                            <img src={config.scan.qrImageUrl} alt="QR Code" className="qr-image" />
                        ) : (
                            <FaQrcode size={30} color="#007bff" />
                        )}
                    </div>
                )}
                {config.inquire?.visible && (
                    <div className="contact-icon inquire" onClick={() => setInquireModalVisible(true)}>
                        <FaCommentDots size={30} color="#fff" />
                    </div>
                )}

                {/* Social Media Icons */}
                {config.socialMedia && config.socialMedia.length > 0 &&
                    config.socialMedia.map((social, index) =>
                        social.visible ? (
                            <a
                                key={index}
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="contact-icon scan"
                            >
                                {social.iconUrl ? (
                                    <img
                                        src={social.iconUrl}
                                        alt={social.platform}
                                        className="qr-image"
                                    />
                                ) : (
                                    <span>{social.platform}</span>
                                )}
                            </a>
                        ) : null
                    )}
            </div>

            {/* QR Modal */}
            {qrModalVisible && (
                <div className="qr-modal" onClick={() => setQrModalVisible(false)}>
                    <img src={config.scan.qrImageUrl} alt="QR Code Enlarged" className="qr-modal-image" />
                </div>
            )}

            {/* Inquiry Modal with Reusable ContactForm */}
            {inquireModalVisible && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            position: "relative",
                            background: "#fff",
                            padding: "40px 20px 20px",
                            borderRadius: "8px",
                            maxWidth: "500px",
                            width: "90%",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        }}
                    >
                        {/* Top-right “×” button */}
                        <button
                            onClick={() => setInquireModalVisible(false)}
                            aria-label="Close"
                            style={{
                                position: "absolute",
                                top: "12px",
                                right: "12px",
                                border: "none",
                                background: "transparent",
                                fontSize: "1.5rem",
                                lineHeight: 1,
                                cursor: "pointer",
                                color: "#666",
                                padding: "4px",
                            }}
                            onMouseOver={e => (e.currentTarget.style.color = "#000")}
                            onMouseOut={e => (e.currentTarget.style.color = "#666")}
                        >
                            &times;
                        </button>

                        <h2 style={{ marginTop: 0, marginBottom: "20px" }}>Send Inquiry</h2>

                        {/* ContactForm */}
                        <ContactForm
                            onFormSubmit={onSubmitInquiry}
                            setResult={setInquireResult}
                            formToken={config.inquire?.formToken}
                        />

                        <span
                            style={{
                                display: "block",
                                marginTop: "15px",
                                color: "#333",
                                fontSize: "1rem",
                            }}
                        >
                            {inquireResult}
                        </span>


                    </div>
                </div>
            )}

        </>
    );
};

export default FloatingContactIcons;
